<template>
  <div>
    <el-row >
      商品名称：<el-input v-model="title" clearable size="mini" style="width: 180px"></el-input>
      <el-button type="primary" size="mini" @click="getTradeData">搜索</el-button>
      <el-button type="primary" size="mini" >批量关闭</el-button>
    </el-row>
    <el-row style="margin-top: 15px">
      <el-col :span="24">
        <el-table border style="font-size: 12px" ref="multipleTable"
                  :data="tradeData" :header-cell-style="{background:'#F2F6FC',color:'#000'}">
          <el-table-column  type="selection"  width="45"> </el-table-column>
          <el-table-column  prop="tid" label="订单号"  width="160px"></el-table-column>
          <el-table-column  prop="buyerNick" label="买家ID" width="120px"></el-table-column>
          <el-table-column  prop="created" label="拍下时间" width="100px"></el-table-column>
          <el-table-column  prop="buyerMessage" label="买家留言" width="180px"></el-table-column>
          <el-table-column  prop="sellerMemo" label="卖家备注" width="180px"></el-table-column>

          <el-table-column  prop="title" label="商品名称" width="200px"></el-table-column>
          <el-table-column  prop="color" label="颜色分类" width="180px"></el-table-column>
          <el-table-column  prop="num" label="数量" width="80px"></el-table-column>
        </el-table>

      </el-col>
    </el-row>

    <div class="block" align="center">
      <span class="demonstration"></span>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageObject.pageCurrent"
        :page-sizes="[5, 10, 20, 50, 100, 5000]"
        :page-size="pageObject.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageObject.rowCount">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"
    export default {
        name: "Close",
      data(){
          return{
            title:'',
            reason:'买家不想买了',
            tradeData:[],
            pageObject: {
              pageCurrent: 1,
              rowCount: 0,
              pageSize: 10
            },
          }
      },
      methods:{
        //改变pageSize
        handleSizeChange: function (val) {
          this.pageObject.pageSize = val;
          this.getTradeData();
        },
        //当前页面改变
        handleCurrentChange: function (val) {
          this.pageObject.pageCurrent = val;
          this.getTradeData();
        },
        getTradeData(){
          let param={
            nick: storage.get('nick'),
            title: this.title,
            pageCurrent: this.pageObject.pageCurrent,
            rowCount: this.pageObject.rowCount,
            pageSize: this.pageObject.pageSize,
          }
          $api.post("/delay/getColse", param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1){
              this.tradeData = dataResult.data.trade;
              let pageObject = dataResult.data.pageObject;
              this.pageObject.rowCount = pageObject.rowCount;
              this.pageObject.pageSize = pageObject.pageSize;
            }else{
              this.$message.error(dataResult.data);
            }
          })
        },
        batClose(){
          const selectData = this.$refs.multipleTable.selection;
          if(selectData.length == 0){
            this.$message.error('请选择要关闭的订单！');
            return
          }
          let tids = '';
          for(let i=0;i<selectData.length;i++){
            tids += tids + ',';
          }
          let param = {
            nick:storage.get('nick'),
            tids: tids,
            reason: this.reason
          }
          $api.post("/delay/batClose", param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1){
              this.getTradeData();
              this.$message.success(dataResult.data);
            }else {
              this.$message.error(dataResult.data);
            }
          })
        },
      },
      mounted(){
        this.getTradeData();
      }
    }
</script>
<style scop
ed>

</style>



// WEBPACK FOOTER //
// src/page/Close.vue